<template>

    <div class="px-6 py-4 bg-minplan-beige">
        <page-title :title="$t('apartments.deleteBuyer')"></page-title>
    </div>

    <jet-form-section @submitted="destroy()">

        <template #form>
            <div class="p-6">
                {{ $t('apartments.confirmDeleteBuyer') }}
            </div>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t('actions.cancel') }}</button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3">
                    {{ $t("actions.delete") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";

export default defineComponent({
    props: ["apartment", "buyer"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton
    },
    data() {
        return {
            form: useForm({})
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        destroy() {
            this.form.delete(this.route("advisors.apartments.destroy.buyer", { apartment: this.apartment.uuid, buyer: this.buyer.id }), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'apartments.buyerDeleted'
                })
            });
        }
    }
});
</script>

<style scoped></style>
